/* Our Boat House — Bali PDP interactivity (scoped to .obhpdp).
   The PDP is now split into several INDEPENDENT Shopify sections, each wrapped in its
   own .obhpdp. This script runs once (loaded by the product section) and operates across
   every .obhpdp on the page. Variants/price/add-to-cart are the theme's (product-form.js). */
(function () {
  'use strict';
  var roots = Array.prototype.slice.call(document.querySelectorAll('.obhpdp'));
  if (!roots.length) return;
  var D = document;

  // Reveal-all (no animation, content just shown) in the theme editor, for headless
  // QA, and when reduced-motion is requested.
  var REVEAL_ALL = navigator.webdriver
    || (window.Shopify && window.Shopify.designMode)
    || matchMedia('(prefers-reduced-motion: reduce)').matches;

  D.querySelectorAll('.obhpdp [data-stagger]').forEach(function (parent) {
    Array.prototype.forEach.call(parent.children, function (child, i) {
      child.classList.add('reveal');
      if (!child.style.getPropertyValue('--i')) child.style.setProperty('--i', i);
    });
  });
  var revealEls = D.querySelectorAll('.obhpdp .reveal, .obhpdp .reveal--scale');
  if (REVEAL_ALL || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  } else {
    // Enable the hidden-then-animate state on EVERY section wrapper (CSS keys off .obhpdp.anim),
    // so content is never invisible if this script doesn't run.
    roots.forEach(function (r) { r.classList.add('anim'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('in'); }); }, 3000);
  }

  /* ---- gallery (in the product section) ---- */
  var main = D.querySelector('.obhpdp #galleryMain');
  var thumbs = Array.prototype.slice.call(D.querySelectorAll('.obhpdp .gallery__thumb'));
  var galIndex = 0;
  function setGallery(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    galIndex = i;
    var img = thumbs[i].querySelector('img');
    if (img && main) main.src = img.getAttribute('data-full') || img.src;
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumbs[i].classList.add('is-active');
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setGallery(i); }); });
  var prev = D.querySelector('.obhpdp .gallery__nav--prev');
  var next = D.querySelector('.obhpdp .gallery__nav--next');
  if (prev) prev.addEventListener('click', function () { setGallery(galIndex - 1); });
  if (next) next.addEventListener('click', function () { setGallery(galIndex + 1); });
  var gallery = D.querySelector('.obhpdp .gallery');
  var zoom = D.querySelector('.obhpdp #galleryZoom');
  if (zoom && gallery) zoom.addEventListener('click', function () { gallery.classList.toggle('is-zoomed'); });
  if (main && gallery) main.addEventListener('click', function () {
    if (gallery.classList.contains('is-zoomed')) gallery.classList.remove('is-zoomed');
  });

  /* ---- spec tabs (in the product section) ---- */
  var tabs = D.querySelectorAll('.obhpdp .tab');
  var panes = D.querySelectorAll('.obhpdp .tabpane');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var name = this.getAttribute('data-tab');
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pane') === name); });
      if (name === 'reviews') { var r = D.querySelector('.obhpdp #reviews'); if (r) r.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ---- FAQ single-open (in the FAQ section). Native <details> works without this;
         this just keeps one open at a time. ---- */
  var faqItems = D.querySelectorAll('.obhpdp .faq details');
  faqItems.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (this.open) faqItems.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ---- normalize fabric/colour names (store uses raw values like "lester_snow_performance") ---- */
  function obhNormalize(s) {
    return (s || '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  // swatch hover-tooltip labels (one-time; values are static per swatch)
  D.querySelectorAll('.obhpdp label[data-variant-title-metafield]').forEach(function (l) {
    l.setAttribute('data-variant-title-metafield', obhNormalize(l.getAttribute('data-variant-title-metafield')));
  });
  // the selected-name shown in the variant legend — keep normalized even after the theme
  // re-renders it on a variant change (guard prevents the observer from looping).
  D.querySelectorAll('.obhpdp [id^="selected-color-name"]').forEach(function (span) {
    function fix() { var raw = span.textContent.trim(); var pretty = obhNormalize(raw); if (raw && raw !== pretty) span.textContent = pretty; }
    fix();
    try { new MutationObserver(fix).observe(span, { childList: true, characterData: true, subtree: true }); } catch (e) {}
  });

  /* ---- sticky add-to-cart bar (in the product section) ---- */
  var stickyBar = D.querySelector('.obhpdp #stickyBar');
  var buybox = D.querySelector('.obhpdp #buybox');
  var footerEl = D.querySelector('.footer, footer');
  if (stickyBar && buybox && 'IntersectionObserver' in window) {
    var pastBuy = false, atFoot = false;
    function syncBar() { stickyBar.classList.toggle('is-visible', pastBuy && !atFoot); }
    new IntersectionObserver(function (es) { pastBuy = es[0].boundingClientRect.bottom < 0; syncBar(); }, { threshold: 0 }).observe(buybox);
    if (footerEl) new IntersectionObserver(function (es) { atFoot = es[0].isIntersecting; syncBar(); }, { threshold: 0 }).observe(footerEl);
    var sCta = stickyBar.querySelector('a[href="#buybox"]');
    if (sCta) sCta.addEventListener('click', function (e) { e.preventDefault(); buybox.scrollIntoView({ behavior: 'smooth' }); });
  }

  /* ---- fabric swatch hover preview: shows the ACTUAL hovered fabric (enlarged) + name.
     Delegated on document + appended to <body> so it survives the theme re-rendering the
     variant picker on selection. ---- */
  var swPreview = null;
  function swEnsure() {
    if (swPreview) return swPreview;
    swPreview = D.createElement('div');
    swPreview.className = 'obh-swatch-preview';
    swPreview.innerHTML = '<span class="obh-swatch-preview__img"></span><span class="obh-swatch-preview__name"></span>';
    D.body.appendChild(swPreview);
    return swPreview;
  }
  function swFrom(el) { return (el && el.closest) ? el.closest('.obhpdp .product-form__input label[data-color]') : null; }
  D.addEventListener('mouseover', function (e) {
    var label = swFrom(e.target);
    if (!label) return;
    var m = (getComputedStyle(label).backgroundImage || '').match(/url\((['"]?)(.*?)\1\)/);
    if (!m) return;
    var url = m[2].replace(/_(?:50x50|48x48|40x40)\./, '_300x300.');
    var p = swEnsure();
    p.querySelector('.obh-swatch-preview__img').style.backgroundImage = 'url("' + url + '")';
    p.querySelector('.obh-swatch-preview__name').textContent = label.getAttribute('data-variant-title-metafield') || '';
    var r = label.getBoundingClientRect();
    p.style.left = (r.left + r.width / 2) + 'px';
    p.style.top = (r.top - 10) + 'px';
    p.classList.add('is-on');
  });
  D.addEventListener('mouseout', function (e) {
    if (!swFrom(e.target)) return;
    if (swFrom(e.relatedTarget)) return; /* moving between swatches — keep open */
    if (swPreview) swPreview.classList.remove('is-on');
  });
})();
